import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/tripLog/map',
    name: 'tripLogMap',
    meta: {
      title: '行驶轨迹',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/tripLog/map/index.vue'),
  },
  {
    path: '/tripLog/history',
    name: 'tripLogHistory',
    meta: {
      title: '历史轨迹',
      isApp: true,
      auth: false,
      keepAlive: true,
    },
    component: () => import('@/views/tripLog/history/index.vue'),
  },
  {
    path: '/tripLog/score',
    name: 'tripLogScore',
    meta: {
      title: '驾驶评分',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/tripLog/score/index.vue'),
  },
]

export default routes
